// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9jVah","option":"styles_option__1LQ_j","active":"styles_active__EAW8_"};